import { createNS } from "@ontologies/core";

const ontola = createNS("https://ns.ontola.io/");

export default {
  ns: ontola,
};
